/**
 * Holds the access token in memory only.
 *
 * Not localStorage and not sessionStorage: anything readable by script on the
 * page is readable by injected script. The refresh token lives in an HttpOnly
 * cookie the page cannot see at all, so a full reload recovers the session via
 * /auth/refresh without the token ever being persisted where script can reach
 * it.
 *
 * The cost is one refresh round-trip on reload. That is the right trade.
 */

let accessToken: string | null = null

export const tokenStore = {
  getAccessToken: () => accessToken,
  setAccessToken: (token: string | null) => {
    accessToken = token
  },
  clear: () => {
    accessToken = null
  },
  isAuthenticated: () => accessToken !== null,
}
